module.exports = __webpack_public_path__ + "img/ring_g_c_0_null.ec9720a5.png";